import React, { useState } from "react";

import TableEntry from "./TableEntry.jsx";
import TableHeader from "./TableHeader.jsx";
import StandardTable from "../../shared/bootstrap/TableWrapper.jsx";

import { SORT_COMPANY_ASC, SEARCH_TYPE_NAME } from "../../../constants.js";
import { contractHolderSortMap } from "../../../util/sort.js";
import { prepareTextForSearch } from "../../../util/format.js";

/**
 * Filter list of smallBusinesses by search text and search type (not case sensitive)
 * @param {Object[]} smallBusinesses
 * @param {string} text
 * @param {number} searchType
 * @returns {Object[]} filtered list of smallBusinesses
 */
const filterByText = (smallBusinesses, text, searchType) => {
  const reg = new RegExp(prepareTextForSearch(text));

  if (searchType === SEARCH_TYPE_NAME) {
    //only search names
    smallBusinesses = smallBusinesses.filter(({ fullName }) => reg.test(fullName.toLowerCase()));
  } else {
    //search everything
    smallBusinesses = smallBusinesses.filter(
      ({ fullName, businessSizes, contracts }) =>
        reg.test(fullName.toLowerCase()) ||
        contracts.some((contract) => reg.test(contract.toLowerCase())) ||
        reg.test(businessSizes.toLowerCase())
    );
  }

  return smallBusinesses;
};

export default function Table({ smallBusinesses, searchValue, searchType }) {
  // Init state
  const [sortOption, setSortOption] = useState(SORT_COMPANY_ASC);
  // sort smallBusinesses data based on sort type
  let sortedSmallBusinesses = smallBusinesses.sort(contractHolderSortMap[sortOption]);

  if (searchValue !== "") {
    sortedSmallBusinesses = filterByText(sortedSmallBusinesses, searchValue, searchType);
  }

  return (
    <StandardTable
      id="smallbusinesslist"
      summary="List of Contract Holders that are classified as small businesses"
      caption="List of Contract Holders that are classified as small businesses"
    >
      <thead role="rowgroup">
        <TableHeader sortOption={sortOption} setSortOption={setSortOption} />
      </thead>
      <tbody role="rowgroup">
        {sortedSmallBusinesses.map(({ chInfoSeq, fullName, displayName, contracts, businessSizes }) => (
          <TableEntry
            key={chInfoSeq}
            chInfoSeq={chInfoSeq}
            fullName={fullName}
            displayName={displayName}
            contracts={contracts}
            businessSizes={businessSizes}
          />
        ))}
      </tbody>
    </StandardTable>
  );
}
